var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 459.15,
    height: 549,
    viewBox: "0 0 459.15 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2783",
    x: 0,
    y: 0,
    width: 459.15,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jpg",
    transform: "translate(8404.5 -1541.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-8450 1557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.5, -15.5)",
    filter: "url(#Path_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783-2",
    "data-name": "Path 2783",
    d: "M365.45,3.125A12.333,12.333,0,0,0,357.159,0H110.9C85.036,0,64,19.135,64,42.667V469.334C64,492.865,85.036,512,110.906,512H439.245c25.869,0,46.9-19.135,46.9-42.667v-352Zm80.665,103.542Z",
    transform: "translate(-45.5 15.5)",
    fill: "#fff",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(-8302.38 1685.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M219.1,252.6H35.759A33.509,33.509,0,0,1,2.25,219.1V35.759A33.509,33.509,0,0,1,35.759,2.25H219.1A33.509,33.509,0,0,1,252.6,35.759V219.1A33.509,33.509,0,0,1,219.1,252.6ZM35.759,21.508A14.251,14.251,0,0,0,21.508,35.759V219.1a14.251,14.251,0,0,0,14.251,14.251H219.1A14.251,14.251,0,0,0,233.346,219.1V35.759A14.251,14.251,0,0,0,219.1,21.508Z",
    transform: "translate(0)",
    fill: "#6200ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M11.857,91.164a9.757,9.757,0,0,1-7.318-3.338A9.629,9.629,0,0,1,5.695,74.216L71.429,18.753a25.677,25.677,0,0,1,34.664,1.412l31.2,31.2a6.419,6.419,0,0,0,8.345,0l30.3-21.954a25.677,25.677,0,0,1,31.326,0l41.726,33.252a9.684,9.684,0,0,1-12.068,15.15l-41.6-33.381a6.419,6.419,0,0,0-7.832,0l-30.3,23.495a25.677,25.677,0,0,1-33.509-2.311l-31.2-31.84a6.419,6.419,0,0,0-8.6,0L18.02,88.981A9.244,9.244,0,0,1,11.857,91.164Z",
    transform: "translate(0.022 123.695)",
    fill: "#6200ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M47.556,76.863A35.306,35.306,0,1,1,82.863,41.556,35.306,35.306,0,0,1,47.556,76.863Zm0-51.355A16.048,16.048,0,1,0,63.6,41.556,16.048,16.048,0,0,0,47.556,25.508Z",
    transform: "translate(118.387 47.355)",
    fill: "#6200ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.cc4b0da84fc1b53b7b32901b2e41082c.svg";
export { ForwardRef as ReactComponent };